<template>
  <div class="zj-layout-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ZjLayoutContainer'
}
</script>
